import { render, staticRenderFns } from "./UserRegistrationRequests.vue?vue&type=template&id=294c1c84&"
import script from "./UserRegistrationRequests.vue?vue&type=script&lang=js&"
export * from "./UserRegistrationRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports